module.exports = __webpack_public_path__ + "static/media/summary.2e291686.svg";